import React from "react";
import HomeMadeShops from "../../pages/Business_dashboard/HomeMadeShops";

const UserDashboard = () => {
  return <HomeMadeShops />;
};

export default UserDashboard;
